/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The cost unit:
 *   * EUR
 */
export enum CostUnit {
  EUR = 'EUR'
}
